import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import sections from 'src/styles/sections';
const useLeaseDetailsStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  attachFile: {
    flexGrow: '1',
    [breakpointsFunc.breakpoints.down('md')]: {
      maxWidth: '100%'
    },
    '&.attached': {
      padding: '16px 24px 8px 24px',
      border: '1px dashed #b8c4ce'
    }
  },
  fieldLg: {
    width: '100%',
    marginRight: '10px'
  },
  fieldMd: {
    width: '240px',
    marginRight: '10px'
  },
  fieldSm: {
    width: '240px'
  },
  fileUploader: {
    flexGrow: '1'
  },
  flexGrow: {
    flexGrow: '1'
  },
  groupWrapperContent: {
    display: 'flex',
    margin: '10px 0',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexWrap: 'wrap'
    }
  },
  leaseInfo: {
    alignItems: 'center',
    display: 'flex',
    marginTop: '-28px',
    justifyContent: 'end',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  personForm: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
    '& .MuiButton-root': {
      backgroundColor: palette.shades[100],
      marginLeft: '10px',
      padding: '12px',
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px'
      }
    }
  }
}));
export default useLeaseDetailsStyles;